// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconDeviceUpdate = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 16 16' ref={ref} {...props}>
        <path
            fill='currentcolor'
            d='M8.833 4.18v6.32a.832.832 0 1 1-1.667 0V4.18L5.255 6.09a.835.835 0 0 1-1.18-1.18L7.41 1.579a.835.835 0 0 1 1.18 0l3.332 3.334a.834.834 0 0 1-1.18 1.18zM3 10.5h3.333c0 .92.747 1.667 1.667 1.667.919 0 1.666-.748 1.666-1.667H13c.919 0 1.666.748 1.666 1.667V13c0 .92-.747 1.667-1.666 1.667H3c-.92 0-1.667-.748-1.667-1.667v-.833c0-.92.747-1.667 1.667-1.667m9.583 2.708a.623.623 0 0 0 .625-.625.624.624 0 0 0-.625-.625.624.624 0 0 0-.625.625c0 .347.279.625.625.625'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconDeviceUpdate)
const Memo = memo(ForwardRef)
export default Memo
